import React from 'react';

import styles from './NewTag.module.css';

const NewTag = () => <span className={styles.root}>NEW</span>;

export default NewTag;
